import * as bootstrap from 'bootstrap'
import { actionsType } from '../../common/constants'
import {
    translation,
    elements,
    prepareFormSubmit,
    handleErrorResponse,
    trackingMBS,
    submitButton,
    displayFeedbackMessage,
    handleAutoLogin,
    retrieveLastSubmittedCode,
    removeCookie,
    enableCodeForm,
    trackingRanch,
    loadScriptSync,
} from './adapter'

// TODO: delete `if` during a permanent switch from Lemonstand to Canvas
// Check localstore for special flags (temporary until total Lemonstand replacement)
if (localStorage.getItem('cxf_canvas') === 'enabled') {
    loadScriptSync(process.env.CANVAS_AGENT_URI || 'https://app.canvas.stillfront.com/agent.js')
}

document.addEventListener('DOMContentLoaded', async () => {
    translation.init()
    const wasErrorHandled = handleErrorResponse()

    const isAutoLoggedIn = handleAutoLogin()

    // With this we are able to identify the loading from the user and ignore those from the error url
    const isFirstLoad = !wasErrorHandled

    if (!isAutoLoggedIn || !isFirstLoad) {
        enableCodeForm()
    }

    if (isFirstLoad) {
        await trackingMBS({
            actionType: actionsType.PAGE_LOADED,
            isAutoLoggedIn: isAutoLoggedIn ? 1 : 0,
        })
    }

    if (!isAutoLoggedIn) {
        retrieveLastSubmittedCode()
    }
    if (elements.input.value?.trim()) {
        submitButton.enable()
    }
})

elements.input.addEventListener('input', () => {
    displayFeedbackMessage(false)

    const code = elements.input.value
    if (code.trim()) {
        submitButton.enable()
    } else {
        submitButton.disable()
    }
})

elements.codeForm.addEventListener('submit', (event) => {
    const code = elements.input.value
    if (!code) {
        event.preventDefault()
        submitButton.disable()
        return
    }

    sessionStorage.setItem('code', code)

    prepareFormSubmit()
})

elements.autoLoginForm.addEventListener('submit', async (event) => {
    // Prevent default form submission to preserve query parameters
    event.preventDefault()

    sessionStorage.removeItem('autologin')
    removeCookie()

    await Promise.all([
        trackingMBS({
            actionType: actionsType.CORRECT_CODE_ENTRY,
            isAutoLoggedIn: 1,
        }),
        trackingRanch(),
    ])

    // Get the success URL stored in the form's dataset
    const successUrl = elements.autoLoginForm.dataset.successUrl

    // Navigate to the success URL with all query parameters preserved
    if (successUrl) {
        window.location.href = successUrl
    }
})

elements.btnFindCode.addEventListener('click', () => {
    const findCodeModal = new bootstrap.Modal(elements.findCodeModal)
    findCodeModal.show()
})
